import { ModalConfig } from '../../../../contexts/modalContext';

import NotifyModal from './NotifyModal';
import ChangeCoverageStartDateModal from './ChangeCoverageStartDateModal';
import CsrOverrideCommentModal from './CsrOverrideCommentModal';
import OverrideSepQepDenialModal from './OverrideSepQepDenialModal';
import CsrOverrideProgramEligibilityModal from './CsrOverrideProgramEligibilityModal';
import CsrOverrideEnrollmentModal from './CsrOverrideEnrollmentModal';
import OverrideSpecialEntrollmentDetailsModal from './OverrideSpecialEntrollmentDetailsModal';
import ShoppingWindowModal from './ShoppingWindowModal';
import ChangeOpenSpecialEnrollment from './ChangeOpenSpecialEnrollment';
import CancelTerminatePlanModal from './CancelTerminatePlanModal';
import OverrideAptcEligibilityStartDateModal from './OverrideAptcEligibilityStartDateModal';

export const modalConfig: ModalConfig = {
    csrOverrideCommentModal: {
        id: 'csrOverrideCommentModal',
        modalComponent: CsrOverrideCommentModal,
    },
    notifyModal: {
        id: 'notifyModal',
        modalComponent: NotifyModal,
    },
    changeCoverageStartDateModal: {
        id: 'changeCoverageStartDateModal',
        modalComponent: ChangeCoverageStartDateModal,
    },
    overrideSepQepDenialModal: {
        id: 'overrideSepQepDenialModal',
        modalComponent: OverrideSepQepDenialModal,
    },
    csrOverrideProgramEligibilityModal: {
        id: 'csrOverrideProgramEligibilityModal',
        modalComponent: CsrOverrideProgramEligibilityModal,
    },
    csrOverrideEnrollmentModal: {
        id: 'csrOverrideEnrollmentModal',
        modalComponent: CsrOverrideEnrollmentModal,
    },
    overrideSpecialEntrollmentDetailsModal: {
        id: 'overrideSpecialEntrollmentDetailsModal',
        modalComponent: OverrideSpecialEntrollmentDetailsModal,
    },
    shoppingWindowModal: {
        id: 'shoppingWindowModal',
        modalComponent: ShoppingWindowModal,
    },
    changeOpenSpecialEnrollment: {
        id: 'changeOpenSpecialEnrollment',
        modalComponent: ChangeOpenSpecialEnrollment,
    },
    cancelTerminatePlanModal: {
        id: 'cancelTerminatePlanModal',
        modalComponent: CancelTerminatePlanModal,
    },
    overrideAptcEligibilityStartDateModal: {
        id: 'overrideAptcEligibilityStartDateModal',
        modalComponent: OverrideAptcEligibilityStartDateModal,
    },
};
